import { PaginatedResponseNebenantragDto } from "../../generated";

/**
 * Maps the generated Required<PageNebenantragDto> (required because no fields are optional in the return) to id
 * @param nebenantragsartDto the API returned nebenantraege page
 * @returns returns the store friendly NebenantraegePage
 */
export const mapNebenantragToNebenantragId = (nebenantraegePageDto: Required<PaginatedResponseNebenantragDto>): number => {
    return nebenantraegePageDto.content.map(nebenantrag => nebenantrag.id)[0];
}